var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40.301,
    height: 32.3,
    viewBox: "0 0 40.301 32.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "mail",
    d: "M36.99,32H3.01a2.832,2.832,0,0,1-2.119-.941A3.158,3.158,0,0,1,0,28.821V3.179A3.158,3.158,0,0,1,.891.941,2.832,2.832,0,0,1,3.01,0H36.99a2.832,2.832,0,0,1,2.119.941A3.158,3.158,0,0,1,40,3.179V28.821a3.158,3.158,0,0,1-.891,2.238A2.832,2.832,0,0,1,36.99,32Zm-22.6-13.355h0L4.754,28.821H35.246L25.612,18.645,20,22.652l-5.612-4.007Zm22.6-8.335-9.329,6.812,9.329,9.856ZM3.01,10.472V26.978L12.339,17.2Zm0-7.293V7.346L20,19.605,36.915,7.266l.076.08V3.179Z",
    transform: "translate(0.15 0.15)",
    fill: "#4f5251",
    stroke: "#4f5251",
    strokeMiterlimit: 10,
    strokeWidth: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMail);
export default __webpack_public_path__ + "static/media/icon-mail.2a289e42f0f3efdaabb6797f15496c85.svg";
export { ForwardRef as ReactComponent };